<div class="page-padding" style="padding: 24px;">
  <div style="margin-left: 39%;" *ngIf="equipmentDetails == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>


  <div class="panel" *ngIf="equipmentDetails != null &&  !showImplementStatusModal">
    <mat-expansion-panel [disabled]="true" [expanded]="true" class="parametersPanel">
      <mat-expansion-panel-header>
        <div class="panel__header">
          <span class="panel__header__title" style="    margin-left: -24px;">
            Implement Rebuild Details
          </span>
        </div>
      </mat-expansion-panel-header>
      <div class="panel__content flex flex--align-center">
        <div class="overall-eval-container">
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
          <div class="bold font-size--xl margin-r--24 {{getEvalClass(equipmentDetails.PercentWorn)}}"
            style="border-radius: 4px;color: white;     padding-top: 12%;">
            {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
          </div>
        </div>
        <div class="column-container flex-grow">
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Family
              </span>
              <span class="text-block__important">
                {{equipmentDetails.CustomerName}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Implement Type
              </span>
              <span class="text-block__important">
                {{equipmentDetails.JobsiteName}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Serial Number
              </span>
              <span class="text-block__important">
                <a routerLink="/equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.SerialNumber}} </a>
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Repairer
              </span>
              <span class="text-block__important">
                <a routerLink="/equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.UnitNumber}}</a>
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Make
              </span>
              <span class="text-block__important">
                {{equipmentDetails.LastInspectionDate}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Model
              </span>
              <span class="text-block__important">
                {{ equipmentDetails.NextInspectionDate }}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Rebuild Start Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Smu}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Rebuild End Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Ltd}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Total Cost
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Make}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Total ebuild Hours
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Model}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Customer
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Family}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Job site
              </span>
              <span class="text-block__important">
                {{equipmentDetails.EquipmentSetupDate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="panel" *ngIf="equipmentDetails != null &&  showImplementStatusModal && !isInRepairer">
    <div class="panel__header">
      <span class="panel__header__title">
        Inventory Details
      </span>
    </div>
    <div class="panel__content flex flex--align-center">

      <div class="column-container flex-grow" style="justify-content: space-evenly;">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Customer
            </span>
            <span class="text-block__important">
              {{equipmentDetails.CustomerName}}
            </span>
          </div>

        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <span class="text-block__important">
              {{equipmentDetails.JobsiteName}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel" *ngIf="ImplementForEquipmentDetails != null &&  showImplementStatusModal && isInRepairer">
    <div class="panel__header">
      <span class="panel__header__title">
        Inventory Details
      </span>
    </div>
    <div class="panel__content flex flex--align-center">

      <div class="column-container flex-grow" style="justify-content: space-evenly;">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Repairer
            </span>
            <span class="text-block__important">
              {{Repairer}}
            </span>
          </div>

        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Work Shop
            </span>
            <span class="text-block__important">
              {{WorkShop}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex columns" *ngIf="equipmentDetails != null">
    <div class="panel panel--tasks" style="flex-shrink: 0.1;width:55%;height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Tasks
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="height: 150px;">

        <a class="square-button" (click)="openMovetoRepairer()" *ngIf="!isJobRoleDefault && !isInRepairer  && isInventory && EnablePreference.showMoveToRepair">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move to Repairer</span>
        </a>

        <a class="square-button"  style="color: lightgrey;" *ngIf="!isJobRoleDefault && isInRepairer  && EnablePreference.showMoveToRepair">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move to Repairer</span>
        </a>
        <a class="square-button" (click)="CreateNewPrePostShipment()" *ngIf=" EnablePreference.showPrePostShipment">
          <i class="material-icons square-button__icon">local_shipping</i>
          <span class="square-button__label">Pre/Post Shipment</span>
        </a>

        <a class="square-button" (click)="openReturnToInventoryFromRepairer()" *ngIf="!isJobRoleDefault && isInRepairer && EnablePreference.showReturnToInventory">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Return to Inventory</span>
        </a>

        <a class="square-button" style="color: lightgrey;" *ngIf="!isJobRoleDefault && !isInRepairer && EnablePreference.showReturnToInventory">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Return to Inventory</span>
        </a>


        <a *ngIf="showImplementStatusModal && implement.status !='Undergoing Rebuild' && !isJobRoleDefault && EnablePreference.showAttachToEquipment" class="square-button" target="_blank" (click)="openAttachImplementModal()" style="width: max-content">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Attach to Equipment</span>
        </a>

        <a class="square-button"  style="color: lightgrey;" *ngIf=" EnablePreference.showImplementAction"> 
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">Implement Action</span>
        </a>
        

        <a *ngIf="!showImplementStatusModal && !isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button" (click)="openChangeJobsite()">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button"
          (click)="openChangeJobsiteInventory()">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="!showImplementStatusModal && isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="showImplementStatusModal  && isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

  
        <a  class="square-button" (click)="OpenAdvcancedCopyPage()" *ngIf="!isJobRoleDefault && EnablePreference.showCopyFrmTemp">
        <i class="material-icons square-button__icon" >content_copy</i>
        <span class="square-button__label" style="min-width: 65px;">Copy from Template</span>
      </a>
      

      


        <a *ngIf="!isJobRoleDefault && EnablePreference.showModifyComponent" class="square-button" (click)="OpenModifyImp()" >
          <i class="material-icons square-button__icon">swap_vert</i>
          <span class="square-button__label">Modify Component</span>
        </a>

        <a *ngIf="showImplementStatusModal && implement.status !='Undergoing Rebuild' && !isJobRoleDefault && EnablePreference.showChangeStatus"
          class="square-button" >
          <i class="material-icons square-button__icon">swap_horiz</i>
          <span class="square-button__label">Change Status</span>
        </a>

        <a *ngIf="!showImplementStatusModal  && !isJobRoleDefault && !isJobRoleDefault && EnablePreference.showProjectContact" class="square-button" (click)="OpenProjectContacts()">
          <i class="material-icons square-button__icon">contact_mail</i>
          <span class="square-button__label">Project Contacts</span>
        </a>
        <a *ngIf="showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showProjectContact" class="square-button"  (click)="OpenProjectContacts()">
          <i class="material-icons square-button__icon">contact_mail</i>
          <span class="square-button__label">Project Contacts</span>
        </a>

        <a *ngIf="!showImplementStatusModal  && isJobRoleDefault && EnablePreference.showProjectContact" style="color: lightgray" class="square-button">
          <i class="material-icons square-button__icon">contact_mail</i>
          <span class="square-button__label">Project Contacts</span>
        </a>
        <a *ngIf="showImplementStatusModal && isJobRoleDefault && EnablePreference.showProjectContact" style="color: lightgray" class="square-button">
          <i class="material-icons square-button__icon">contact_mail</i>
          <span class="square-button__label">Project Contacts</span>
        </a>

        <a *ngIf="isJobRoleDefault && EnablePreference.showProjectPartsLists" style="color: lightgray" class="square-button">
          <i class="material-icons square-button__icon">receipt_long</i>
          <span class="square-button__label">Project Parts List</span>
        </a>

        <a *ngIf="!isJobRoleDefault && EnablePreference.showProjectPartsLists" class="square-button" (click)="OpenPartList()">
          <i class="material-icons square-button__icon">receipt_long</i>
          <span class="square-button__label">Project Parts List</span>
        </a>
       

      </div>
    </div>


    <div class="panel panel--inspections" style="margin-left:15px;width: 512px; height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Inspection History
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="overflow-x: auto;     justify-content: start;">

        <div class="square-button" *ngFor="let inspection of inspectionDetails;" [ngClass]="getBackColour(inspection.Status)"
          (click)="openInspection(inspection)">

          <div class=" CelltextWrap" style="width: 100px;text-align: center;">
            <span class="square-button__label CelltextWrap  " style="color: rgb(0, 0, 0); padding: 1px;"
              title="{{inspection.FECRInspectionType}}">{{inspection.FECRInspectionType}}</span>
          </div>

          <span class="smuReadings">{{inspection.Status}}</span>
          <span class="square-button__label" style="margin-top: 10px;">{{inspection.StartDate}}</span>
          <!-- <mat-menu #inspectionMenu="matMenu">
            <button *ngIf="!isJobRoleDefault" mat-menu-item
              (click)="openLink('impinspection', inspection.InspectionDate, inspection)">{{'View / Edit'}}</button>
          </mat-menu> -->
        </div>
      </div>
    </div>
  </div>
  <mat-tab-group>

    <div *ngIf="equipmentDetails != null">
      <div style="margin-left: 39%;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
      </div>
      <mat-tab label="IMPLEMENT DETAILS">
        <div *ngIf="ImplementForEquipmentDetails != null">

          <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
            <div style="overflow-x: auto; " class="mat-elevation-z8">

              <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
                <app-fecr-implement-details-header [Implemetdetails]="implement.ImplementSummary"
                  [evaldetails]="ImplementForEquipmentDetails"></app-fecr-implement-details-header>
              </div>
              <ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints ;let i = index">
                <app-fecr-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId" [(implementId)]="implementId" [selectedIndex]="i" (updateObs)="loadImplementDetails()">
                </app-fecr-observation-details>
              </ng-container>

            </div>
          </ng-container>

        </div>
      </mat-tab>

    </div>
  </mat-tab-group>
</div>
